import React from 'react';
import './Loading.css';

interface LoadingProps {
    fullScreen?: boolean;
    size?: 'small' | 'medium' | 'large';
}

export const Loading: React.FC<LoadingProps> = ({ fullScreen = false, size = 'medium' }) => {
    return (
        <div className={`loading-container ${fullScreen ? 'fullscreen' : ''}`}>
            <div className={`spinner ${size}`}></div>
        </div>
    );
};
